import React from 'react';
import PropTypes from 'prop-types';
import FlexContainer from '../FlexContainer/FlexContainer';
import Label from '../Label/Label';
import Tooltip from '../Tooltip/Tooltip';

const TruncatedList = ({
  items = [],
  maxVisible = 4,
  getLabel = (item) => item,
  getKey = (item, index) => index,
  emptyPlaceholder = '-',
  moreVariant = 'info',
  tooltipPosition = 'top',
}) => {
  if (!items || items.length === 0) {
    return emptyPlaceholder;
  }

  const visibleLabels = items.slice(0, maxVisible).map(getLabel).join(', ');
  const hiddenCount = items.length - maxVisible;

  if (hiddenCount <= 0) {
    return visibleLabels;
  }

  return (
    <FlexContainer gap="6px" alignItems="center">
      <span>{visibleLabels}</span>
      <Tooltip
        position={tooltipPosition}
        keepOnHover={true}
        content={
          <FlexContainer flexDirection="column" flexFlow="column" gap="4px">
            {items.map((item, index) => (
              <span key={getKey(item, index)}>{getLabel(item)}</span>
            ))}
          </FlexContainer>
        }
      >
        <Label variant={moreVariant}>{`+${hiddenCount} more`}</Label>
      </Tooltip>
    </FlexContainer>
  );
};

TruncatedList.propTypes = {
  items: PropTypes.array,
  maxVisible: PropTypes.number,
  getLabel: PropTypes.func,
  getKey: PropTypes.func,
  emptyPlaceholder: PropTypes.node,
  moreVariant: PropTypes.string,
  tooltipPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right', 'bottom-end']),
};

export default TruncatedList;
